<script>
    import R, {LOADER} from "../lib/requests";
    import {setFocusTo} from "../lib/lib";
    import Modal from '../components/modal/Modal.svelte';
    import Alert from "../stores/alerts";
    import Notifier from "../stores/notifier";
    import AssignedUser from "../components/controls/AssignedUser.svelte";

    export let clientId = null;
    export let closeCallback;

    let client = null;
    let modalTitle = 'Πελάτης';

    const load = () => {

        const onSuccess = result => {
            client = result;
            setFocusTo('name');
        }

        const onFailure = err => {
            Alert.warning("Πελάτης", err.message);
        };

        R.handle(R.client.details, clientId, onSuccess, onFailure, LOADER.POPUP);
    };

    const save = () => {

        const onSuccess = result => {
            close(result);
            Notifier.showMessage("Ο πελάτης ενημερώθηκε");
        }

        const onFailure = err => {
            let fields = {
                name: 'Όνομα',
                email: 'Email'
            }
            let prompt = '';
            let focusTo = err.params && err.params.field ? err.params.field : null;
            if (err.code === 'field_required') {
                prompt = `Το πεδίο "${fields[err.params.field]}" είναι απαιτούμενο!`;
            } else if (err.code === 'field_invalid') {
                prompt = `Το πεδίο "${fields[err.params.field]}" δεν είναι έγκυρο!`;
            }

            if (prompt) {
                Notifier.showError(prompt);
                setFocusTo(focusTo);
            } else {
                Alert.warning("Πελάτης", err.message);
            }
        };

        if (!client.name.trim()) {
            Notifier.showError("Πληκτρολογήστε ένα όνομα για τον Πελάτη!");
            setFocusTo('name');
            return;
        }

        let action = client.id === 0 ? 'create' : 'edit';
        R.handle(R.client[action], client, onSuccess, onFailure, LOADER.POPUP);
    }


    const initialize = () => {
        if (!clientId) {
            client = {
                id: 0,
                name: '',
                email: '',
                phone: '',
                mobile: '',
                owner_id: 0,
            };

            modalTitle = 'Νέος πελάτης';
            setFocusTo('name');
        } else {
            load();
        }
    }

    const close = (param) => {
        client = null;

        if (param instanceof Event) {
            closeCallback();
            return;
        }

        setTimeout(() => {
            closeCallback(param);
        }, 200);
    }

    initialize();
</script>

{#if client}
    <Modal title="{ modalTitle }" icon="client" closeOnEscape="{ true }" on:close="{ close }">
        <div slot="body">
            <div class="form-group">
                <h6 class="mb-2">Όνομα</h6>
                <input type="text" class="form-control" id="name"
                       bind:value="{ client.name }"
                       required>
            </div>
            <div class="form-group">
                <label>Email</label>
                <input type="email" class="form-control" id="email" bind:value="{ client.email }">
            </div>
            <div class="row">
                <div class="col-md-6 form-group">
                    <label>Τηλέφωνο</label>
                    <input type="tel" class="form-control" bind:value="{ client.phone }">
                </div>
                <div class="col-md-6 form-group">
                    <label>Κινητό</label>
                    <input type="tel" class="form-control" bind:value="{ client.mobile }">
                </div>
            </div>
            <div class="form-group">
                <label>Ανάθεση</label>
                <AssignedUser bind:userId={client.owner_id} />
            </div>
            <hr class="full-hr">
            <div class="text-end">
                <div class="btn btn-link me-4" on:click="{ () => close() }">Κλείσιμο</div>
                <button class="btn btn-primary" on:click={ save }>ΕΝΗΜΕΡΩΣΗ</button>
            </div>
        </div>
    </Modal>
{/if}